import React from 'react';

/**
 * Marca Silent Puma — pata entre colchetes, em vetor.
 * Substitui o PNG de 51x53px (que tinha 48% dos pixels semitransparentes).
 *
 *   <Logo />                          lockup horizontal, tamanho padrão
 *   <Logo size={40} />                só o ícone, 40px
 *   <Logo wordmark={false} />         só o ícone
 *   <Logo variant="mono" />           mono claro (sobre indigo, sobre foto)
 *   <Logo variant="ink" />            mono escuro (papel branco)
 *   <Logo brackets={false} />         só a pata — favicon, abaixo de 24px
 */

const COLORS = {
  brand: '#9184D9',
  mono: '#E9E9ED',
  ink: '#161826',
};

export const Mark = ({ size = 28, variant = 'brand', brackets = true, className, ...rest }) => {
  const c = COLORS[variant] || COLORS.brand;
  const paw = (
    <g fill={c}>
      <ellipse cx="19.5" cy="30" rx="4.3" ry="6.1" transform="rotate(-30 19.5 30)" />
      <ellipse cx="27.6" cy="23.4" rx="4.5" ry="6.6" transform="rotate(-12 27.6 23.4)" />
      <ellipse cx="36.4" cy="23.4" rx="4.5" ry="6.6" transform="rotate(12 36.4 23.4)" />
      <ellipse cx="44.5" cy="30" rx="4.3" ry="6.1" transform="rotate(30 44.5 30)" />
      <path d="M32 35.5c7.2 0 12 4.3 12 9.8 0 5.9-5.4 9.7-12 9.7s-12-3.8-12-9.7c0-5.5 4.8-9.8 12-9.8Z" />
    </g>
  );

  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="Silent Puma"
      {...rest}
    >
      {brackets && (
        <g fill="none" stroke={c} strokeWidth="3" strokeLinecap="square">
          <path d="M12.5 7.5H5.5v49h7" />
          <path d="M51.5 7.5h7v49h-7" />
        </g>
      )}
      {/* abaixo de 24px os colchetes fecham: a pata cresce 16% e ocupa o quadro */}
      {brackets ? paw : <g transform="translate(32 33) scale(1.16) translate(-32 -32)">{paw}</g>}
    </svg>
  );
};

const Logo = ({
  size = 28,
  variant = 'brand',
  wordmark = true,
  brackets = true,
  className = '',
  ...rest
}) => {
  const inkFirst = variant === 'ink' ? COLORS.ink : COLORS.mono;
  const inkSecond = variant === 'ink' ? '#595d6c' : '#b2b6ca';

  return (
    <span className={`sp-logo ${className}`.trim()} {...rest}>
      <Mark size={size} variant={variant} brackets={brackets} />
      {wordmark && (
        <span className="sp-logo-word" style={{ fontSize: Math.round(size * 0.61), color: inkFirst }}>
          Silent<span style={{ color: inkSecond }}> Puma</span>
        </span>
      )}
    </span>
  );
};

export default Logo;
